import { useContext, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

import { GlobalContext, GlobalContextType } from 'context/GlobalContext';
import { InitStore, useInitStore } from 'stores/useInitStore';
import { UserStore, useUserStore } from 'stores/useUserStore';

interface ConfirmModalProps {
  show: boolean;
  hide: (flag: boolean) => void;
  title: string;
  content: string;
  positiveBtnText: string;
  negativeBtnText: string;
}

const ConfirmModal = ({ show, hide, title, content, positiveBtnText, negativeBtnText }: ConfirmModalProps) => {
  const location = useLocation();
  const { triggerGTMDataLayer } = useContext(GlobalContext) as GlobalContextType;

  const { user } = useUserStore((state: UserStore) => ({
    user: state.user,
  }));

  const { initData } = useInitStore((state: InitStore) => ({
    initData: state.initData,
  }));

  useEffect(() => {
    setTimeout(() => {
      triggerGTMDataLayer({
        event: 'MyAccountPageView',
        pagePath: `/${title.toLowerCase().replaceAll(' ', '-')}`,
        pageTitle: `${user?.csUserid ? 'CS:' : ''} ${initData?.clientName} - ${title}`,
      });
    }, 1000);

    return () => {
      triggerGTMDataLayer({
        event: 'MyAccountPageView',
        pagePath: location.pathname,
        pageTitle: `${user?.csUserid ? 'CS:' : ''} ${window.document.title}`,
      });
    };
  }, [initData?.clientName, location.pathname, title, triggerGTMDataLayer, user?.csUserid]);

  return (
    <Modal
      backdrop="static"
      show={show}
      onHide={() => {
        hide(false);
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div dangerouslySetInnerHTML={{ __html: content }}></div>
      </Modal.Body>
      <Modal.Footer>
        <button
          onClick={() => {
            hide(false);
          }}
          type="button"
          className="btn agiaBlueButton-outline"
          data-dismiss="modal"
        >
          {negativeBtnText}
        </button>

        <button
          onClick={() => {
            hide(true);
          }}
          type="button"
          className="btn agiaBlueButton"
          data-dismiss="modal"
        >
          {positiveBtnText}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
